// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chi_yu: PokeData = {
  "id": 1004,
  "name": "chi-yu",
  "height": 4,
  "weight": 49,
  "base_experience": 285,
  "types": [
    PokeType.DARK,
    PokeType.FIRE
  ],
  "api_moves": [
    "ember",
    "confuse-ray",
    "flame-wheel",
    "spite",
    "swagger",
    "mean-look",
    "will-o-wisp",
    "memento",
    "overheat",
    "bounce",
    "payback",
    "dark-pulse",
    "nasty-plot",
    "lava-plume",
    "flame-charge",
    "incinerate",
    "inferno",
    "ruination"
  ],
  "moves": [
    "ember",
    "confuse-ray",
    "dark-pulse",
    "blaze-kick",
    "snarl",
    "sunny-day",
    "dark-bargain",
    "fire-ball",
    "snatch",
    "fire-punch",
    "night-slash",
    "morning-sun",
    "flamethrower"
  ],
  "evolution_chain": {
    "id": 532,
    "item": null,
    "species": [
      {
        "name": "chi-yu",
        "order": 997,
        "types": [
          PokeType.DARK,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 99,
    "speed": 128,
    "ability_power": 173
  },
  "stat_changes": [],
  "catch_rate": 6,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
